export default function Lights() {
  return (
    <>
      <directionalLight position={[-3, 3, 2]} intensity={3.5} />
    </>
  );
}
